import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Alert, AlertTitle } from '@mui/material';
import { ASSISTANT_COPY, FROM_ASSISTANT_PARAM, FROM_ASSISTANT_VALUE } from '../../constants/assistantCopy';

/**
 * For the upload screens when the user came from Claude / Town
 * (`?from=assistant`, set by /assistant/upload/...). Instead of redirecting to
 * the folder after a successful upload they stay put and say "go back to your
 * chat" — the folder view is not where this user is headed.
 */
export const useAssistantReturn = () => {
  const [searchParams] = useSearchParams();
  const fromAssistant = searchParams.get(FROM_ASSISTANT_PARAM) === FROM_ASSISTANT_VALUE;
  const [done, setDone] = useState(false);
  return { fromAssistant, done, markDone: () => setDone(true) };
};

export const AssistantDoneBanner = ({ sx }) => (
  <Alert severity="success" sx={{ borderRadius: '12px', ...sx }}>
    <AlertTitle sx={{ fontWeight: 700 }}>{ASSISTANT_COPY.uploaded}</AlertTitle>
    {ASSISTANT_COPY.uploadedHint}
  </Alert>
);
